import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { Person } from "@/services/DTOs/Person";
import { OpportunitiesApiService } from "./OpportunitiesApiService";

class Service {
  public createErrorLog(statusCode: number, user?: Person, err?: string): Observable<void> {
    const url = `/api/suite/people/log/${statusCode}?origin=discovery` + (err ? `&errorMessage=${err}` : "") +
      (user && user.subjectId ? `&subjectId=${user.subjectId}` : "");
    return OpportunitiesApiService.get(url).pipe(map(() => undefined));
  }

  public shortenUrl(url: string): Observable<string> {
    const baseUrl = `/api/suite/shorten-url?url=${encodeURIComponent(url)}`;
    return OpportunitiesApiService.post(baseUrl, {}).pipe(map((response) => response.data));
  }
}

export const TrackingService = new Service();
